import { FC } from 'react';
import { Icons } from '@silverfort/sf-components';
import BlockPageMainImage from '../../assets/blockPageImage.png';
import { BlockPage, BlockPageProps } from '../../../../routings/pages/BlockPage/BlockPage';

const topics: BlockPageProps['rightContent']['topics'] = [
    'Enroll, manage, and safeguard all users in one place.',
    'Unify users to singular identities for a seamless, secure experience.',
    'Bring your own tokens for end-to-end MFA coverage everywhere.',
    'Unlock Policy Insights to validate enforcement and optimize protection.'
];

const UniversalMfaBlockPage: FC = () => {
    return (
        <BlockPage
            leftContent={{
                title: 'Universal MFA',
                image: BlockPageMainImage
            }}
            rightContent={{
                topics,
                icon: Icons.ShieldUser,
                accessLink: 'https://www.silverfort.com/mfa-signup/?utm_source=PQL&utm_content=locked',
                title: 'Discover Universal MFA',
                description: 'Protect every identity with agentless Universal MFA and actionable insights.',
                badgeProps: {
                    text: 'License Upgrade',
                    color: 'positive'
                }
            }}
        />
    );
};

export default UniversalMfaBlockPage;
